const DEFAULT_PER_PAGE_VALUE = 50;

export type SourcePagination<T, Keys extends string> = {
  page: number;
  per_page: number;
  total_count: number;
} & { [K in Keys]: Array<T> };

export default interface Pagination<T> {
  page: number;
  perPage: number;
  totalCount: number;
  records: Array<T>; // TODO: right now API returns named property of the type its returned. IE: resource: Resource
}

export interface PaginationParams {
  page?: number;
  perPage?: number;
}

export interface WithoutPagination<T> {
  records: Array<T>;
}

export function initPagination<ParamsType extends PaginationParams>(
  params: ParamsType
): ParamsType {
  const { page = 1, perPage = DEFAULT_PER_PAGE_VALUE } = params;

  return {
    ...params,
    page,
    perPage,
  };
}
